import React, { useEffect, useState } from 'react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';

interface DeleteAllContactsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteAllContactsModal: React.FC<DeleteAllContactsModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [confirmationText, setConfirmationText] = useState('');
  const isDeleteEnabled = confirmationText.trim() === 'DELETE';

  useEffect(() => {
    if (!isOpen) {
      setConfirmationText('');
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete All Contacts">
      <p className="text-gray-600 mb-6">
        Are you sure you want to delete ALL contacts? This action cannot be
        undone and will permanently remove all contacts from your workspace.
      </p>
      <div className="mb-6">
        <label className="mb-2 block text-sm font-medium text-foreground">
          Type <span className="font-semibold">DELETE</span> to confirm
        </label>
        <input
          type="text"
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          placeholder="DELETE"
          className="w-full rounded-lg border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none"
        />
      </div>
      <div className="flex justify-end gap-3">
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          disabled={!isDeleteEnabled}
          className="bg-destructive hover:bg-destructive-hover"
        >
          Delete All Contacts
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteAllContactsModal;
